export const SET_VISIBLE_FIELDS = 'profileDetails/SET_VISIBLE_FIELDS'
export const SAVE_DETAILS_FIELD_ORDER_SUBMIT = 'profileDetails/SAVE_DETAILS_FIELD_ORDER_SUBMIT'
export const RESET_DETAILS_FIELDS_TO_DEFAULT_SUBMIT = 'profileDetails/RESET_DETAILS_FIELDS_TO_DEFAULT_SUBMIT'

export const SET_ADMIN_VISIBLE_FIELDS = 'profileDetails/SET_ADMIN_VISIBLE_FIELDS'
export const SAVE_ADMIN_DETAILS_FIELD_ORDER_SUBMIT = 'profileDetails/SAVE_ADMIN_DETAILS_FIELD_ORDER_SUBMIT'
export const RESET_ADMIN_DETAILS_FIELDS_TO_DEFAULT_SUBMIT = 'profileDetails/RESET_ADMIN_DETAILS_FIELDS_TO_DEFAULT_SUBMIT'
